import React from 'react';
import './App.css';
import Div100vh from 'react-div-100vh'
import HttpsRedirect from 'react-https-redirect';
import MainContainer from './components/MainContainer/MainContainer';

function App() {
  return (
    <HttpsRedirect>
      <Div100vh>
        <div id="App">
          <MainContainer />
        </div>
      </Div100vh>
    </HttpsRedirect>
  );
}

export default App;
